import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19.218 20.25H4.781V3.75h10.313l4.125 4.125V20.25zM18.187 9.167c0-.079-.011-.17-.023-.261h-4.103V4.781h-8.25v14.426l12.375.011V9.166zm-3.093-1.292h2.64a1.146 1.146 0 0 0-.159-.181l-2.289-2.301a1.17 1.17 0 0 0-.193-.147v2.629z"
}), 'File');